import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import "katex/dist/katex.min.css";
import { loadAdSenseScript } from "./lib/loadAdSense";

loadAdSenseScript();

const rootEl = document.getElementById("root");
if (rootEl) {
  createRoot(rootEl).render(<App />);
  document.body.classList.add("app-ready");
}
